module.exports = __webpack_public_path__ + "img/logo-xi.8e9786b5.png";